import React from 'react'
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts'

type DistributionChartProps = {
  title: string
  items: { name: string; value: number; color: string }[]
}

export const DistributionChart: React.FC<DistributionChartProps> = ({ title, items }) => {
  return (
    <article className='dashboard-v2__mini-card'>
      <div className='card-head'>
        <h3>{title}</h3>
      </div>
      <div className='pie-wrap pie-wrap--design'>
        <ResponsiveContainer width='100%' height={250}>
          <PieChart>
            <Pie
              data={items}
              dataKey='value'
              nameKey='name'
              innerRadius={0}
              outerRadius={92}
              paddingAngle={0}
              cornerRadius={0}
              startAngle={90}
              endAngle={-270}
              stroke='none'
            >
              {items.map((item) => (
                <Cell key={item.name} fill={item.color} />
              ))}
            </Pie>
            <Tooltip formatter={(value) => Number(value || 0).toFixed(2)} />
          </PieChart>
        </ResponsiveContainer>
        <div className='legend legend--design'>
          {items.map((item) => (
            <div key={item.name} className='legend-item'>
              <i style={{ background: item.color }} />
              <span className='legend-item-name'>{item.name}</span>
            </div>
          ))}
        </div>
      </div>
    </article>
  )
}
